import React, { PropsWithChildren } from 'react'

const COUNT_LABEL_STYLES =
  'm-auto font-body font-normal text-center text-darkgray text-sm'

interface ICountLabelProps {
  fontSize?: string
}

export const CountLabel: React.FC<PropsWithChildren<ICountLabelProps>> = ({
  children,
}) => {
  return <p className={COUNT_LABEL_STYLES}>{children}</p>
}

CountLabel.displayName = 'Content.CountLabel'
